import widgets from '../widgets'

const {
  STATUS,
  ALARM_STATE,
} = widgets

export default [
  STATUS({}),
  ALARM_STATE({}),
]
